class Basic {
  constructor(config) {
    this.allConfig = config
  }
  //根据传入configIndex获得对应的值, 匹配失败时返回defaultValue(默认返回false)
  getAppointed(configKey, configIndex, defaultValue) {
    defaultValue = defaultValue || '';
    if (!this.allConfig.hasOwnProperty(configKey) || configIndex == null) {
      return defaultValue;
    }
    let config = this.allConfig[configKey];
    return config.hasOwnProperty(configIndex) ? config[configIndex] : defaultValue;
  }
  //以键值对的形式获得所有配置
  getConfigList(configKey) {
    if (!this.allConfig.hasOwnProperty(configKey)) {
      return false;
    }
    return this.allConfig[configKey];
  }
}

export default Basic